import { render, staticRenderFns } from "./JwJiaoshiModal.vue?vue&type=template&id=587ccc04&scoped=true"
import script from "./JwJiaoshiModal.vue?vue&type=script&lang=js"
export * from "./JwJiaoshiModal.vue?vue&type=script&lang=js"
import style0 from "./JwJiaoshiModal.vue?vue&type=style&index=0&id=587ccc04&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "587ccc04",
  null
  
)

export default component.exports